<template>
  <div class="pc-list" ref="list">
    <UserSearch @search="search" ref="reSearch" />
    <!-- <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteNewsInit">删除</button>
          <span></span>
          <button @click="addNews">添加</button>
          <span></span>
          <button @click="exportNews">导出数据</button>
        </div>
        <p>{{ "共 " + searchRules.total + " 条" }}</p>
      </div>
    </div> -->
    <el-table
      class="pc-list-table"
      :data="userList"
      @sort-change="changeSort"
      v-loading="loading"
    >
      <el-table-column
        prop="user_id"
        label="UserID"
        width="300"
        fixed="left"
      ></el-table-column>
      <el-table-column
        label="username"
        width="150"
        prop="username"
        fixed="left"
      >
      </el-table-column>

      <el-table-column prop="email" label="email" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.email">
            {{ scope.row.email }}
          </div>
          <div v-else>暂无</div>
        </template>
      </el-table-column>
      <el-table-column label="phone" width="120" prop="phone">
      </el-table-column>

      <el-table-column label="注册时间" prop="registered_time" width="120">
        <template slot-scope="scope">
          <div>
            {{ $dtime(scope.row.registered_time).format("YYYY.MM.DD") }}
          </div>
        </template>
      </el-table-column>
      <!-- sortable="custom" -->
      <el-table-column label="最近登录时间" prop="login_time" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.login_time">
            {{ $dtime(scope.row.login_time).format("YYYY.MM.DD") }}
          </div>
          <div v-else>暂无</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="120">
        <template slot-scope="scope">
          <button
            class="btnViewDetail"
            @click="viewDetail(scope.row)"
          >
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="userList.length > 0"
      :pagination="searchRules"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import UserSearch from "./UserSearch";
import DeleteHint from "../../../template/DeleteHint";
import Pagination from "../../../componentSet/Pagination";
import { getUserList_Api } from "../../../../apis/user.api";

export default {
  props: ["total"],
  components: {
    UserSearch,
    DeleteHint,
    Pagination,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 12,
        order: "-id",
        take: 12,
        total: 0,
        register_time:[],
        login_time:[]
      },
      userList: [],
      checked: [],
    };
  },
  mounted() {
    this.getUserListByRules(this.searchRules);
  },

  methods: {
    getUserListByRules(data) {
      this.loading = true;
      getUserList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.userList = res.data;
          this.searchRules.total = res.count
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getUserListByRules(data);
    },
    search(formData) {
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules, data);
      this.getUserListByRules(data);
      this.searchRules.page = 1;
    },
    dealSearchRules(formData) {
      console.log(formData)
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.user_id) {
        data.user_id = formData.user_id;
      }
      if (formData.username) {
        data.username = formData.username;
      }
      if (formData.register_time.length!=0) {
        data.register_start_time = this.$dtime(formData.register_time[0]).format("YYYY-MM-DD");
        data.register_end_time = this.$dtime(formData.register_time[1]).format("YYYY-MM-DD");
      }
       if (formData.login_time.length!=0) {
        data.login_start_time = this.$dtime(formData.login_time[0]).format("YYYY-MM-DD");
        data.login_end_time = this.$dtime(formData.login_time[1]).format("YYYY-MM-DD");
      }
      return data;
    },
    deleteNewsInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    addNews() {
      let route = this.$router.resolve({
        path: "/admin/newsdetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    viewDetail(item) {
      item.read_flag = 1;
      let route = this.$router.resolve({
        path: "/admin/userDetail",
        query: { id: item.user_id },
      });
      window.open(route.href, "_blank");
    },

    changeStatus(row) {
      updateNews_Api({ news_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },

    goPage(pageNo) {
      this.searchRules.page = pageNo;
      
      let data = this.dealSearchRules(this.searchRules);
      console.log(data)
      this.getUserListByRules(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-list {
  @include table-head;
  .active {
    color: $base-color;
    background: $timeBtn;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userList/UserTable.vue